import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

interface ITitleProps {
  text: string;
  isRequired?: boolean;
}

export const Title = ({ text, isRequired = false }: ITitleProps) => (
  <Typography as="span" color={colors.neutral[600]} size="body_large" bold>
    {text}

    {isRequired && (
      <Typography as="span" color={colors.neutral[500]} size="body_large" style={{ marginLeft: 4 }}>
        (Required)
        <Typography as="span" color={colors.error[500]} size="body_large">
          *
        </Typography>
      </Typography>
    )}
  </Typography>
);
